// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"a0609672","453":"920e9b88"}[chunkId] + ".chunk.js";
};